import { BarberEmployee, DateInfo, Slot } from "../../Model";
import { BarberRepository } from "../../Repository";

export async function dateSelected(
  date: DateInfo,
  repository: BarberRepository
): Promise<Slot[]> {
  return repository.setSelectedDate(date);
}
